import React, { useRef, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Pressable,
  Alert,
  TextInput,
  StatusBar,
  Platform
} from 'react-native';


import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ScreenWrapper from '../../Components/ScreenWrapper';
import BackButton from '../../Components/BackButton';
import Button from '../../Components/Button';
import Input from '../../Components/Input';
import {User, Mail, Lock} from '../../../assets/icons';
import { hp, wp } from '../../helpers/common';
import { theme } from '../../constants/theme';
import { Supabase } from '../../Utils/supabase.config';
import { useNavigation } from '@react-navigation/native';
import {NativeStackNavigationProp} from '@react-navigation/native-stack';
import {AuthStackNavigationParms} from './AuthenticationStack';
import { updateUser } from '../../services/userService';
type Props = {
  navigation: NativeStackNavigationProp<AuthStackNavigationParms, 'SignUp'>;
};
const SignUp: React.FC<Props> = ({navigation}) => {
  const navigation1 = useNavigation();
  const emailRef = useRef<string>('');
  const nameRef = useRef<string>('');
  const passwordRef = useRef<string>('');
  const [loading, setLoading] = useState<boolean>(false);  

  const onSubmit = async () => {
    if (!nameRef.current || !emailRef.current || !passwordRef.current) {
      Alert.alert('Sign up', 'Please fill all the fields!');
      return;
    }

    const name = nameRef.current.trim();
    const email = emailRef.current.trim();
    const password = passwordRef.current.trim();

    setLoading(true);

    const {
      data: { session, user },
      error,
    } = await Supabase.auth.signUp({
      email,
      password,
      options: {
        data: { name },
      },
    });

    if (error) {
      Alert.alert('Sign up', error.message);
      setLoading(false);
      return;
    }

    // Set from_web = true for web registrations (mobile defaults to false)
    if (user && Platform.OS === 'web') {
      try {
        // Update users table to set from_web = true for web registrations
        const updateResult = await updateUser(user.id, { from_web: true });
        if (!updateResult.success) {
          console.warn('Failed to update from_web flag:', updateResult.msg);
          // Don't show error to user, registration was successful
        }
      } catch (updateError) {
        console.error('Error updating from_web flag:', updateError);
        // Don't show error to user, registration was successful
      }
    }

    setLoading(false);
  };

  return (
    <ScreenWrapper bg="white">
      <StatusBar backgroundColor={'black'} barStyle="light-content"></StatusBar>
      <View style={styles.container}>
         {/* back button */}
        <View>
          <BackButton navigation={navigation1} />
        </View>

        <View>
          <Text style={styles.welcomeText}>Let's</Text>
          <Text style={styles.welcomeText}>Get Started</Text>
        </View>

        <View style={styles.form}>
          <Text style={{ fontSize: hp(1.5), color: theme.colors.text }}>
            Please fill the details to create an account
          </Text>
          <Input
            icon={<User size={26} strokeWidth={1.6} />}
            placeholder="Enter your name"
            placeholderTextColor={theme.colors.textLight}
            onChangeText={(value: string) => (nameRef.current = value)}
          />
          <Input
            icon={<Mail size={26} strokeWidth={1.6} />}
            placeholder="Enter your email"
            placeholderTextColor={theme.colors.textLight}
            onChangeText={(value: string) => (emailRef.current = value)}
          />
          <Input
            icon={<Lock size={26} strokeWidth={1.6} />}
            secureTextEntry
            placeholder="Enter your password"
            placeholderTextColor={theme.colors.textLight}
            onChangeText={(value: string) => (passwordRef.current = value)}
          />

          <Button title="Sign up" loading={loading} onPress={onSubmit} />
        </View>

        <View style={styles.footer}>
          <Text style={styles.footerText}>Already have an account!</Text>
          <Pressable onPress={() => navigation.navigate('SignIn')}>
            <Text
              style={[
                styles.footerText,
                {
                  color: theme.colors.primaryDark,
                  fontWeight: '600', // change to string literal
                },
              ]}
            >
              Login
            </Text>
          </Pressable>
        </View>
      </View>
    </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 45,
    paddingHorizontal: wp(5),
  },
  welcomeText: {
    fontSize: hp(4),
    fontWeight: '700',
    color: theme.colors.text,
  },
  form: {
    gap: 25,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
  },
  footerText: {
    textAlign: 'center',
    color: theme.colors.text,
    fontSize: hp(1.6),
  },
});

export default SignUp;
